function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { withEventBoundary, useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { ListingSearchAutocomplete } from '@domain-group/fe-co-allhomes-autocomplete';
import useSearchHandlers from './use-search-handlers';
import Menu from '../menu';
import { jsx as ___EmotionJSX } from "@emotion/core";
var tabGroups = [[{
  label: 'BUY',
  id: ListingType.SALES_RESIDENTIAL.name
}, {
  label: 'NEW HOMES',
  id: ListingType.DEVELOPMENTS_RESIDENTIAL.name
}, {
  label: 'RENT',
  id: ListingType.RENTAL_RESIDENTIAL.name
}, {
  label: 'SHARE',
  id: ListingType.SHARE_RESIDENTIAL.name
}], [{
  label: 'FOR LEASE',
  id: ListingType.RENTAL_COMMERCIAL.name
}, {
  label: 'FOR SALE',
  id: ListingType.SALES_COMMERCIAL.name
}, {
  label: 'BUSINESS',
  id: ListingType.SALES_BUSINESS.name
}]];
var getListingType = listingTypeName => ListingType[listingTypeName] || ListingType.SALES_RESIDENTIAL;
var SearchMenu = _ref => {
  var _ref$listingType = _ref.listingType,
    initialListingTypeName = _ref$listingType === void 0 ? ListingType.SALES_RESIDENTIAL.name : _ref$listingType,
    _ref$onSearch = _ref.onSearch,
    onSearch = _ref$onSearch === void 0 ? () => {} : _ref$onSearch,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? () => {} : _ref$onClose;
  var _useState = useState(getListingType(initialListingTypeName)),
    _useState2 = _slicedToArray(_useState, 2),
    listingType = _useState2[0],
    setListingType = _useState2[1];
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var searchHandlers = useSearchHandlers({
    listingType: listingType.name,
    immediateTypes: ListingSearchAutocomplete.immediateTypes,
    onRedirect: onSearch
  });
  var effectiveListingType = listingType.name === ListingType.OFF_MARKET.name ? ListingType.SALES_RESIDENTIAL : listingType;
  var tabs = tabGroups.find(tabGroup => tabGroup.find(tab => tab.id === effectiveListingType.name)) || [];
  var handleTabClick = (index, tab) => {
    sendEvent('option-select', {
      index,
      tab
    });
    setListingType(getListingType(tab.id));
  };
  return ___EmotionJSX(ListingSearchAutocomplete, _extends({}, searchHandlers, {
    showRecent: true,
    saveRecentOnSearch: true,
    variant: "modal",
    alwaysOpen: true,
    listingType: effectiveListingType.name,
    onCloseModal: onClose,
    extensions: {
      modalSuggestionSheet: ___EmotionJSX(Menu, {
        orientation: "row",
        indicator: true,
        items: tabs.map((tab, index) => _objectSpread(_objectSpread({}, tab), {}, {
          onClick: () => handleTabClick(index, tab)
        })),
        activeItem: effectiveListingType.name
      })
    }
  }));
};
export default withEventBoundary('search')(SearchMenu);